import { render, staticRenderFns } from "./dvr-media-upload.vue?vue&type=template&id=a889b9d4&scoped=true&"
import script from "./dvr-media-upload.vue?vue&type=script&lang=js&"
export * from "./dvr-media-upload.vue?vue&type=script&lang=js&"
import style0 from "./dvr-media-upload.vue?vue&type=style&index=0&id=a889b9d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a889b9d4",
  null
  
)

export default component.exports